(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('site-location', {
            parent: 'entity',
            url: '/site-location',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'SiteLocations'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site-location/site-locations.html',
                    controller: 'SiteLocationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                clinic: ['CoreService', function (CoreService) {
                    return CoreService.getCurrentClinic();
                }]
            }
        })
        .state('site-location-detail', {
            parent: 'entity',
            url: '/site-location/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'SiteLocation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site-location/site-location-detail.html',
                    controller: 'SiteLocationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SiteLocation', function($stateParams, SiteLocation) {
                    return SiteLocation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'site-location',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('site-location-detail.edit', {
            parent: 'site-location-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-location/site-location-dialog.html',
                    controller: 'SiteLocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SiteLocation', function(SiteLocation) {
                            return SiteLocation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('site-location.new', {
            parent: 'site-location',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-location/site-location-dialog.html',
                    controller: 'SiteLocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CoreService', function (CoreService) {
                            return {
                                name: null,
                                id: null,
                                clinic: CoreService.getCurrentClinic()
                            };
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-location', null, { reload: 'site-location' });
                }, function() {
                    $state.go('site-location');
                });
            }]
        })
        .state('site-location.edit', {
            parent: 'site-location',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-location/site-location-dialog.html',
                    controller: 'SiteLocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SiteLocation', function(SiteLocation) {
                            return SiteLocation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-location', null, { reload: 'site-location' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('site-location.delete', {
            parent: 'site-location',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-location/site-location-delete-dialog.html',
                    controller: 'SiteLocationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SiteLocation', function(SiteLocation) {
                            return SiteLocation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-location', null, { reload: 'site-location' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }

})();
